<app-modal-shell
  [title]="data.title"
  [primaryLabel]="'Add'"
  [primaryDisabled]="!(applicationForm.valid && isFormChanged())"
  [errorMessage]="isErrorVisible ? errorMessage : null"
  (closed)="closePopup()"
  (submitted)="handleSubmit()"
>
  <form [formGroup]="applicationForm" class="form-body">
    <!-- Application Name -->
    <app-input
      [inputStyle]="'popup-form-field'"
      [label]="appNameLabel"
      [formCntlName]="applicationName"
      [placeholder]="appNamePlaceholder"
      [required]="true"
      [inputType]="'text'"
      [maxLength]="appNameMaxLength"
    >
    </app-input>
    @if (applicationName?.hasError('required') && applicationName?.touched) {
      <mat-error class="mat-error-msg" i18n>Application name is required.</mat-error>
    }
    @if (applicationName?.hasError('whitespace') && applicationName?.touched) {
      <mat-error class="mat-error-msg" i18n>Input cannot be just spaces.</mat-error>
    }

    <!-- Description -->
    <app-input
      [formCntlName]="description"
      [inputType]="'textarea'"
      [label]="descriptionLabel"
      [placeholder]="descriptionPlaceholder"
      [rows]="4"
      [maxLength]="descriptionMaxLength"
    ></app-input>
    <div class="char-counter">{{ description?.value?.length || 0 }} / {{ descriptionMaxLength }}</div>
    @if (description?.hasError('whitespace') && description?.touched) {
      <mat-error class="mat-error-msg" i18n>Input cannot be just spaces.</mat-error>
    }
  </form>
</app-modal-shell>
